module.exports = __webpack_public_path__ + "static/fast-bb386a70619f832de35c08d72c2c46b9.png";